import { useTranslation } from "react-i18next";
import ServiceDeviceDetails from "../components/ServiceDeviceDetails";
import LastServicesList from "../components/LastServicesList";
import ServiceDeviceSelector from "../components/ServiceDeviceSelector";
import { useDeviceServiceData } from "../ServiceHooks/useDeviceServiceData";
import { useEffect } from "react";

const CreateServiceFormStepOne = ({ values, form, update }) => {
  const { t } = useTranslation();

  const {
    options,
    selectedDevice,
    setSelectedDevice,
    lastServices,
    serviceBaseSelect,
    getDevices,
    fetchLastServices,
  } = useDeviceServiceData(values, form);

  return (
    <div>
      <ServiceDeviceSelector
        t={t}
        values={values}
        form={form}
        options={options}
        serviceBaseSelect={serviceBaseSelect}
        getDevices={getDevices}
        setSelectedDevice={setSelectedDevice}
        fetchLastServices={fetchLastServices}
        update={update}
      />

      <div className="step-one-wrapper">
        <div className="col-left">
          <ServiceDeviceDetails device={selectedDevice} />
        </div>

        <div className="col-right">
          <LastServicesList
            services={lastServices}
            deviceUuid={selectedDevice?.uuid}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateServiceFormStepOne;
